import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { lifecycle, compose, withHandlers, withProps } from 'recompose'
import { push } from 'react-router-redux'

import * as OrgActions from 'modules/org/actions'
import * as OrgSelectors from 'modules/org/selectors'
import * as UserActions from 'modules/user/actions'
import * as UserSelectors from 'modules/user/selectors'
import * as RoutingSelectors from 'modules/routing/selectors'
import { page, track } from 'utils/trackingUtils'

import Welcome from './component'

import { messagesByLocale } from 'utils/translations'

const mapStateToProps = state => ({
  welcomeMessage: OrgSelectors.getWelcomeMessage(state),
  userId: UserSelectors.getUserId(state),
  locale: OrgSelectors.getLocale(state),
  name: UserSelectors.getName(state),
  pathname: RoutingSelectors.getPathname(state)
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    setWelcomeMessage: OrgActions.setWelcomeMessage,
    updateEmbed: OrgActions.updateEmbed,
    updateUser: UserActions.updateUser,
    updateWelcomeMessage: OrgActions.updateWelcomeMessage,
    setName: UserActions.setName,
    setLocale: OrgActions.setLocale,
    updateOrgProperties: OrgActions.updateOrgProperties,
    push
  }, dispatch)
})

export default compose(
  connect(mapStateToProps,mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      this.props.actions.updateOrgProperties({ properties: { lastStep: this.props.pathname } })
      page('Onboarding Welcome Message Setup', {
        context: 'widget-onboarding',
      })
    }
  }),
  withHandlers({
    onWelcomeMessageChange: props => event => {
      props.actions.setWelcomeMessage(event.target.value)
    },
    onNameChange: props => event => {
      props.actions.setName(event.target.value)
    },
    onLocaleChange: props => ({ value }) => {
      props.actions.setLocale(value)
    },
    onContinueClick: props => () => {
      track('Onboarding Welcome Message Setup Completed', {
        context: 'widget-onboarding',
        skipped: false,
      })
      props.actions.updateUser({
        name: props.name,
      })
      props.actions.updateWelcomeMessage({ onlineText: (props.welcomeMessage || messagesByLocale[props.locale]["app.newConversation.welcomeMessage"]), offlineText: messagesByLocale[props.locale]["messenger.offlineFeedback.awayMessageDefaultCopy"] })
      props.actions.updateEmbed([{
        operation: 'set',
        value: props.locale,
        property: 'locale',
      }])
      props.actions.push('/setup/touchless/details')
    },
  }),
  withProps(props => {
    return {
      disabled: !props.name,
    }
  })
)(Welcome)



// WEBPACK FOOTER //
// ./src/layouts/Welcome/index.js